import { Injectable } from '@angular/core';

import { ApiService } from '../../../../../common/services/api.service';
import { environment } from 'src/environments/environment';
import { apiEndPoints } from '../../../../../common/constants/api-endpointsconstant';
import { ReportService } from 'src/app/reports/services/report.service';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class WarehouseInventoryv2Service {

  constructor(
    private apiServive: ApiService,
    private reportService: ReportService,
    private translate: TranslateService
  ) { }

   warehouseUnitSizePayload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }

  projectsPayload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }

  landPricesPayload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }

  propertyTransactionPayload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }

  getOverviewDataInventoryV2(){
    let queryParams = {...this.reportService.queryParams};
    if(queryParams?.transaction_date) {
      queryParams['transaction_date'] = queryParams?.transaction_date.split(',')[0];
    }
      const changeParams = this.reportService.setfilterQueryParams(queryParams);
      const url: string = `${environment.miUrl}${apiEndPoints.warehouseInventoryOverviewReportv2}${changeParams}`;
      return this.apiServive.get(url, false);
  }

  getOverviewSummary() {
    let queryParams = { ...this.reportService.queryParams };
    if(queryParams?.transaction_date) {
      queryParams['year'] = this.reportService.getTTMmaxYear(queryParams?.transaction_date);
        delete queryParams['transaction_date'];
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.warehouseRentalOverviewReportV2}${changeParams}`;
    return this.apiServive.get(url, false);
  }
  

  getOverviewSummaryrentalYield() {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.warehouseRentalOverviewRentalYieldReportV2}${changeParams}`;
    return this.apiServive.get(url, false);
  }
  
  getChartsDataBarAndWater(type:string=''){
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.warehouseInventoryOverviewGraphv2}${changeParams}&type=${type}`;
    return this.apiServive.get(url, false);
  }

  getWarehouseRentRateReport(){
   let queryParams = {...this.reportService.queryParams};
    if(queryParams?.transaction_date) {
      queryParams['transaction_date'] = queryParams?.transaction_date.split(',')[0];
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.warehouseRentalRentrateReportV2}${changeParams}`;
    return this.apiServive.get(url, false);
  }

  
  getWarehouseUnitSize(payload: any) {
    let queryParams = {...this.reportService.queryParams};
    if(queryParams?.transaction_date) {
      queryParams['transaction_date'] = queryParams?.transaction_date.split(',')[0];
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.warehouseRentalRentUnitsizeReportV2}${changeParams}&limit=${payload?.pageSize}&offset=${offset}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    if(offset == 0){
      url += "&is_count=true"
    }
    return this.apiServive.get(url, false);
  }


  getwarehouseInventProjects(payload:any){
    let queryParams = {...this.reportService.queryParams};
    if(queryParams?.transaction_date) {
       queryParams['year'] = this.reportService.getTTMmaxYear(queryParams?.transaction_date);
          delete queryParams['transaction_date'];
      }

    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.warehouseRentalProjectReportV2}${changeParams}&limit=${payload?.pageSize}&offset=${offset}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    if(offset == 0){
      url += "&is_count=true"
    }
    return this.apiServive.get(url, false);

  }

  getLandprices(payload: any, type:string = ''){
    let queryParams = {...this.reportService.queryParams};
  
    if(queryParams?.transaction_date) {
      queryParams['transaction_date'] = queryParams?.transaction_date.split(',')[0];
    }
    if(type) {
      queryParams['price_type'] = type;
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.warehouseInventoryLandPriceReportv2}${changeParams}&limit=${payload?.pageSize}&offset=${offset}`;
    if(payload.sort_order){
      url += `&sort_order=${payload.sort_order}`;
    }

    if(offset == 0){
      url += "&is_count=true"
    }
    return this.apiServive.get(url);
  }


  getPropertyTransaction(payload: any, type:string = ''){
    let queryParams = {...this.reportService.queryParams};

    if(queryParams?.transaction_date) {
      queryParams['transaction_date'] = queryParams?.transaction_date.split(',')[0];
    }
    if(type) {
      queryParams['price_type'] = type;
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.warehouseInventoryPropertyTransactionReportv2}${changeParams}&limit=${payload?.pageSize}&offset=${offset}`;
    if(payload.sort_order){
      url += `&sort_order=${payload.sort_order}`;
    }

    if(offset == 0){
      url += "&is_count=true"
    }
    return this.apiServive.get(url);
  }

  


}
